import SelectSystemVariantDialog, { TypeAddContact } from './SelectSystemVariantDialog'

export default SelectSystemVariantDialog
export type { TypeAddContact }
